import { lazy } from 'react';
import { D as DefaultTranslationComp } from './en-US-BgCUkLcw.js';

/* eslint-disable quotes, quote-props, comma-dangle, max-len */
// eslint-disable-next-line @typescript-eslint/no-unused-vars

const translationImports = {
  'ar-AE': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--ar-AE" */'./ar-AE-ChoTtUYk.js'),
  'de-DE': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--de-DE" */'./de-DE-Cal5XTtb.js'),
  'en-AU': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--en-AU" */'./en-AU-BrLs270Q.js'),
  'en-CA': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--en-CA" */'./en-CA-DBp6v-Pb.js'),
  'en-GB': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--en-GB" */'./en-GB-COmdppct.js'),
  'en-IN': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--en-IN" */'./en-IN-DE6Y7ICE.js'),
  'en-SG': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--en-SG" */'./en-SG-jRNOQG9Q.js'),
  'es-CO': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--es-CO" */'./es-CO-C1z4geam.js'),
  'es-ES': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--es-ES" */'./es-ES-DttDS1Kl.js'),
  'es-MX': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--es-MX" */'./es-MX-TuPNBlQt.js'),
  'fr-CA': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--fr-CA" */'./fr-CA-DKRgbOlj.js'),
  'fr-FR': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--fr-FR" */'./fr-FR-CT4Ejw6v.js'),
  'hi-IN': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--hi-IN" */'./hi-IN-AspQJ_Xm.js'),
  'it-IT': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--it-IT" */'./it-IT-Dn6T63JX.js'),
  'ja-JP': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--ja-JP" */'./ja-JP-iKqEaD0u.js'),
  'ko-KR': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--ko-KR" */'./ko-KR-N0nSpdkk.js'),
  'nl-NL': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--nl-NL" */'./nl-NL-CZI-Fkp0.js'),
  'pl-PL': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--pl-PL" */'./pl-PL-DOSSA3iZ.js'),
  'pt-BR': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--pt-BR" */'./pt-BR-5brXih06.js'),
  'sv-SE': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--sv-SE" */'./sv-SE-DEuLCi96.js'),
  'ta-IN': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--ta-IN" */'./ta-IN-DeOAknD6.js'),
  'th-TH': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--th-TH" */'./th-TH-DyYCGk3Y.js'),
  'tr-TR': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--tr-TR" */'./tr-TR-OyH9kEg4.js'),
  'vi-VN': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--vi-VN" */'./vi-VN-ySIEK_GJ.js'),
  'zh-CN': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--zh-CN" */'./zh-CN-BRP6ZyCD.js'),
  'zh-TW': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--zh-TW" */'./zh-TW-BaRQw2Wr.js')
};
const translationComps = Object.entries(translationImports).reduce((acc, [localCode, importFn]) => ({
  ...acc,
  [localCode]: /*#__PURE__*/lazy(importFn)
}), {});
function getTranslationComponent(locale) {
  return {
    component: locale && locale in translationComps ? translationComps[locale] : DefaultTranslationComp,
    locale: locale && locale in translationComps ? locale : 'en-US',
    translationImports
  };
}

export { getTranslationComponent as g };
//# sourceMappingURL=index-B1V68-dy.js.map
